import React, { PureComponent } from "react";
import { connect } from "react-redux";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { buildingSearchColumns } from "./columnConfig";

class MatTableHead extends PureComponent {
	createSortHandler = (property) => (event) => {
		const { onRequestSort } = this.props;
		onRequestSort(event, property);
	};

	render() {
		const {
			onSelectAllClick,
			order,
			orderBy,
			numSelected,
			rowCount,
			visibleColumns,
		} = this.props;

		const activeColumns = buildingSearchColumns.filter(
			(col) => col.alwaysVisible || visibleColumns.includes(col.id)
		);

		return (
			<TableHead>
				<TableRow>
					<TableCell padding="checkbox">
						<Checkbox
							className={`material-table__checkbox ${
								numSelected === rowCount
									? "material-table__checkbox--checked"
									: ""
							}`}
							indeterminate={numSelected > 0 && numSelected < rowCount}
							checked={numSelected > 0 && numSelected === rowCount}
							onChange={onSelectAllClick}
						/>
					</TableCell>
					{activeColumns.map((col) => (
						<TableCell
							className="material-table__cell material-table__cell--sort material-table__cell-right"
							key={col.id}
							align="left"
							padding="default"
							sortDirection={orderBy === col.id ? order : false}
						>
							{col.sortable ? (
								<TableSortLabel
									active={orderBy === col.id}
									direction={order}
									onClick={this.createSortHandler(col.id)}
									className="material-table__sort-label"
									dir="ltr"
								>
									{col.label}
								</TableSortLabel>
							) : (
								<span>{col.label}</span>
							)}
						</TableCell>
					))}
				</TableRow>
			</TableHead>
		);
	}
}

export default connect((state) => ({
	user: state.user,
}))(MatTableHead);
